import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="m12.593 13.635 2.696-2.695H7.187a.93.93 0 0 1-.932-.932.94.94 0 0 1 .932-.932h8.102L12.594 6.38a.92.92 0 0 1-.271-.66.92.92 0 0 1 .271-.661.92.92 0 0 1 1.322 0l4.304 4.287a.92.92 0 0 1 0 1.323l-4.288 4.288a.92.92 0 0 1-1.322 0 .94.94 0 0 1-.017-1.323Z" />
    <path d="M8.034 3.432a.93.93 0 0 1-.932.932H4.255v11.272h2.847a.93.93 0 0 1 .932.932.93.93 0 0 1-.932.932h-3.78a.93.93 0 0 1-.932-.932V3.432a.93.93 0 0 1 .932-.932h3.78a.93.93 0 0 1 .932.932" />
  </svg>
);
export default SvgLogout;
